var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AssetMarker',_vm._g({attrs:{"asset":_vm.asset,"is-selected":_vm.isSelected,"interactive":_vm.interactive,"visible":_vm.visible,"information-pills":_vm.informationPills,"small":_vm.small}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }